import { atom } from 'jotai'
import { BvnkNetworkConnectionsResponse } from 'types/bvnkNetwork'

export const bvnkNetworkConnectionsAtom = atom<BvnkNetworkConnectionsResponse>({})
bvnkNetworkConnectionsAtom.debugLabel = 'bvnk-network-connections'

export const isFetchingConnectionsAtom = atom(false)
isFetchingConnectionsAtom.debugLabel = 'is-fetching-connections'

export const isFetchingConnectionsErrorAtom = atom(false)
isFetchingConnectionsErrorAtom.debugLabel = 'is-fetching-connections-error'
